import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AccountCooldownStatus {
  client_id: string;
  name: string;
  blocked: boolean;
  cooldown_until: string | null;
  stage: number;
  resumes_at: string | null;
  held: number;
}

export function useAccountCooldownStatus(clientIds: (string | null | undefined)[], scopeKey?: string | null) {
  const ids = Array.from(new Set(clientIds.filter(Boolean) as string[])).sort();
  return useQuery({
    queryKey: ["account-cooldown-status", scopeKey ?? null, ids],
    enabled: ids.length > 0,
    refetchInterval: 60_000,
    queryFn: async (): Promise<Record<string, AccountCooldownStatus>> => {
      const { data, error } = await (supabase as any).rpc("get_account_cooldown_status", { p_client_ids: ids });
      if (error) { console.error("[cooldown-status] failed", error); throw error; }
      const map: Record<string, AccountCooldownStatus> = {};
      for (const r of (data || []) as AccountCooldownStatus[]) map[r.client_id] = r;
      return map;
    },
  });
}

export function formatResume(iso: string | null, timeZone?: string | null) {
  if (!iso) return "—";
  const tz = timeZone || "Asia/Kolkata";
  try {
    return new Date(iso).toLocaleString("en-IN", { timeZone: tz, weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  }
}
